module.exports = __webpack_public_path__ + "img/wall-logo-small.e7fa6342.jpg";